class PriceReview extends HTMLElement {
  constructor() {
    super();
    this.setupMutationObserver();
  }

  setupMutationObserver() {
    const observer = new MutationObserver(() => {
      const hasYotpoWidget = this.querySelector('.jdgm-widget, .jdgm-prev-badge__text');
      const priceElement = this.querySelector('[data-review-price]');

      if (hasYotpoWidget && priceElement) {
        // Move price element and reveal it
        hasYotpoWidget.insertBefore(priceElement, hasYotpoWidget.firstChild);
        priceElement.classList.remove('hidden');
        this.classList.add('active');
        observer.disconnect(); // optional: stop observing once done
      }
    });

    observer.observe(this, {
      childList: true,
      subtree: true
    });
  }
}

if (!customElements.get('price-review')) {
  customElements.define('price-review', PriceReview);
}
